<script>
    import Module6 from "./module6.svelte";
    import Humburger from "./humburger.svelte";
    import IMask from "imask";
    import { onMount } from "svelte";
    import WorkingOut from "./workingOut.svelte";
    export let formType = 'guide';

    let textList = [
        "Программа маршрута.",
        "Описание маршрута (каждого дня - если это путеводитель поездки на несколько дней). Включает детальные описания с указанием адресов и комментариев, облегчающих выбор и планирование поездок.",
        "Описание мест. Предоставляет информацию о режиме работы, содержании и полезных советах при посещении каждого места. Интерактивное оглавление путеводителя позволяет переходить между разделами.",
    ];

    let full_name = "";
    let phone_number = "";
    let email = "";
    let successMessage = "";
    let errorMessage = "";
    let maskInstance;

    onMount(() => {
        const element = document.getElementById("phone_number");
        maskInstance = IMask(element, {
            mask: "+{7}(000)000-00-00",
            lazy: false,
        });
    });

    const handleSubmit = async () => {
        errorMessage = "";
        successMessage = "";

        if (maskInstance) {
            phone_number = maskInstance.unmaskedValue;
        }

        if (!full_name || !phone_number || !email) {
            errorMessage = "Пожалуйста, заполните поля имени и email.";
            return;
        }

        if (!/^[+7]\d{10}$/.test(phone_number)) {
            errorMessage =
                "Некорректный номер телефона. Пожалуйста, введите корректный номер в формате +7XXXXXXXXXX.";
            return;
        }

        try {
            const response = await fetch("/submit", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ full_name, phone_number, email, formType }),
            });

            if (response.ok) {
                successMessage =
                    "Данные успешно отправлены! Для подтверждения номера и почты, мы свяжемся с вами telegram.";
                full_name = "";
                phone_number = "";
                email = "";
            } else {
                const errorData = await response.json();
                errorMessage = errorData.error || "Ошибка отправки данных.";
            }
        } catch (error) {
            errorMessage = "Ошибка сети. Пожалуйста, попробуйте позже.";
            console.error("Error:", error);
        }
    };

    let isMobile = window.innerWidth < 1200;
</script>

{#if isMobile}
    <WorkingOut />
{:else}
    <div class="moduleGuide">
        <div class="blockColor">
            <div class="arrow">
                <a href="/" class="arrow-link">
                    <span class="arrow-icon">&#8594;</span>
                </a>
            </div>
        </div>
        <div class="blockText">
            <h1 class="text1">
                Путеводитель представляет собой структурированное руководство,
                разделенное на три основных блока:
            </h1>
            <hr class="hr" />
            {#each textList as text, i}
                <p class="text2">
                    <span class="block-number">Блок {i + 1}:</span>
                    {text}
                </p>
            {/each}

            <!-- Добавляем форму -->
            {#if successMessage}
                <p style="color: green;">{successMessage}</p>
            {/if}
            {#if errorMessage}
                <p style="color: red;">{errorMessage}</p>
            {/if}

            <form on:submit|preventDefault={handleSubmit} class="contact-form">
                <div class="form-group">
                    <label for="full_name">Имя:</label>
                    <input
                        type="text"
                        id="full_name"
                        bind:value={full_name}
                        required
                    />
                </div>
                <div class="form-group">
                    <label for="phone_number">Номер телефона:</label>
                    <input type="tel" id="phone_number" />
                </div>
                <div class="form-group">
                    <label for="email">Email:</label>
                    <input
                        type="email"
                        id="email"
                        bind:value={email}
                        required
                    />
                </div>
                <button type="submit">Отправить</button>
            </form>
        </div>
    </div>

    <Module6 />
    <Humburger />
{/if}

<style>
    .blockColor {
        width: 100%;
        height: 60px;
        background-color: #4f7942;
        margin-bottom: 30px;
    }
    .arrow {
        margin: 0 auto;
        max-width: 50%;
        height: 60px;
        display: flex; /* Добавляем flexbox */
        flex-direction: column; /* Выравниваем по вертикали */
        justify-content: center;
    }
    .arrow-link {
        display: inline-block;
        position: relative;
        color: #eaf4e5;
        text-decoration: none;
    }
    .arrow-icon {
        position: absolute;
        font-size: 24px;
        transform: translateY(-50%) rotate(180deg);
    }

    .blockText {
        /* margin-top: 40px; */
        max-width: 50%;
        margin: 0 auto;
        margin-bottom: 40px;
    }
    .text1 {
        margin: 0 auto;
        color: #4f7942;
        text-align: center;
        font-size: 30px; /*Размер шрифта*/
        font-weight: 600; /*Толщина*/
        /* margin-bottom: 35px; */
    }
    .text1:focus-visible {
        outline: none;
        border: none;
    }
    .hr {
        border-top: 2px solid #4f7942;
        max-width: 60%;
        /* margin-top: 20px; */
        margin-bottom: 20px;
    }
    .text2 {
        font-size: 20px; /*Размер шрифта*/
        font-weight: 400;
        color: #4f7942;
        text-align: left;
    }
    .block-number {
        font-size: 20px; /*Размер шрифта*/
        font-weight: 600;
    }

    form {
        margin-top: 20px;
    }
    .contact-form {
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 400px; /* Adjust as needed */
        margin: 20px auto;
    }
    .form-group {
        margin-bottom: 15px;
        color: #4f7942;
    }
    label {
        margin-bottom: 5px;
    }
    input[type="text"],
    input[type="tel"],
    input[type="email"] {
        padding: 8px;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-sizing: border-box;
        width: 100%;
    }
    button[type="submit"] {
        background-color: #4f7942;
        color: white;
        padding: 10px 15px;
        border: none;
        border-radius: 4px;
        cursor: pointer;
    }
</style>
